import {useCallback, useContext} from 'react';

import {ValidationContext} from 'src/contexts/validation-context';
import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getLifeAgentSettings, saveLifeAgentSettings} from 'src/openapi/admin/apis/LifeAgentApi';
import {useAppDispatch} from 'src/store/hooks';

import {
    AVAILABLE_ON_CONTROL,
    AVAILABLE_ON_TO_BEFORE_START_ERROR,
    AVAILABLE_ON_TO_BEFORE_START_MESSAGE,
} from './constants';

import type {LifeAgentSettings} from 'src/openapi/admin/models/LifeAgentSettings';

export const useLiveAgentSettings = () => {
    const apiDispatch = useAppDispatch();
    const {addError, validationErrors, removeError} = useContext(ValidationContext);

    const getDispatchAction = useCallback(() => apiDispatch(
        getLifeAgentSettings(),
    ), [apiDispatch]);

    const saveDispatchAction = useCallback((lifeAgentSettings: Array<LifeAgentSettings>) => apiDispatch(
        saveLifeAgentSettings({
            lifeAgentSettings,
        }),
    ), [apiDispatch]);

    const editValidation = useCallback((updatedSettings: Array<LifeAgentSettings>) => {
        updatedSettings.forEach(({startTime, endTime, isActive, weekDay}) => {
            if (isActive) {
                const [startHour, startMinute] = startTime.split(':');
                const [endHour, endMinute] = endTime.split(':');

                if (+startHour > +endHour || (+startHour === +endHour && +startMinute > +endMinute)) {
                    addError({
                        controlId: `${AVAILABLE_ON_CONTROL}-${weekDay}`,
                        code: AVAILABLE_ON_TO_BEFORE_START_ERROR,
                        message: AVAILABLE_ON_TO_BEFORE_START_MESSAGE,
                    });
                } else {
                    removeError(`${AVAILABLE_ON_CONTROL}-${weekDay}`);
                }
            } else {
                removeError(`${AVAILABLE_ON_CONTROL}-${weekDay}`);
            }
        });
    }, [addError, removeError]);

    const saveValidation = useCallback(() => !validationErrors.length, [validationErrors]);

    return useCommonDataHook({
        initValue: [],
        getDispatchAction,
        saveDispatchAction,
        editValidation,
        saveValidation,
    });
};
